__turbopack_context__.v({
  "active": "a0dubq_active",
  "dash": "a0dubq_dash",
  "desktopProgress": "a0dubq_desktopProgress",
  "progress": "a0dubq_progress",
  "sliderWrapper": "a0dubq_sliderWrapper",
  "thumbnailImage": "a0dubq_thumbnailImage",
  "thumbnailSliderWrapper": "a0dubq_thumbnailSliderWrapper",
  "thumbnailWrapper": "a0dubq_thumbnailWrapper",
});
